const PREF_KEY = "fv_zap_sound";
let ctx = null;

export const isZapSoundOn = () => localStorage.getItem(PREF_KEY) !== "off";
export const setZapSoundOn = (on) => localStorage.setItem(PREF_KEY, on ? "on" : "off");

const getContext = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!ctx) ctx = new Ctx();
  return ctx;
};

const noiseBuffer = (ac, seconds) => {
  const buf = ac.createBuffer(1, Math.floor(ac.sampleRate * seconds), ac.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
  return buf;
};

const playStatic = (ac, t0, seconds) => {
  const src = ac.createBufferSource();
  src.buffer = noiseBuffer(ac, seconds);
  const band = ac.createBiquadFilter();
  band.type = "bandpass";
  band.frequency.value = 1800;
  band.Q.value = 0.6;
  const gain = ac.createGain();
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.18, t0 + 0.03);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + seconds);
  src.connect(band).connect(gain).connect(ac.destination);
  src.start(t0);
  src.stop(t0 + seconds);
};

const playBlip = (ac, t0, freq, seconds) => {
  const osc = ac.createOscillator();
  osc.type = "square";
  osc.frequency.setValueAtTime(freq, t0);
  const gain = ac.createGain();
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.09, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + seconds);
  osc.connect(gain).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + seconds);
};

/** CRT "zap": static burst + two-tone tuner blip. Silently no-ops without a prior user gesture. */
export const playZapSound = () => {
  if (!isZapSoundOn()) return;
  const ac = getContext();
  if (!ac || ac.state === "suspended") return;
  const t0 = ac.currentTime + 0.02;
  playStatic(ac, t0, 0.45);
  playBlip(ac, t0 + 0.42, 880, 0.09);
  playBlip(ac, t0 + 0.54, 1320, 0.14);
};
